export const initialAbility = [
  {
    action: 'read',
    subject: 'Page',
  },
]

export const _ = undefined
